export const NOTIFY_PANEL_SUCCESS_TOAST =
  'We’ll email you when this program is available on-demand';
export const NOTIFY_PANEL_ERROR_TOAST = 'The request cannot be sent, try again later';
export const NOTIFY_PANEL_SUCCESS_HEADER =
  'Thank you, we’ll update you when this program is available on demand';
export const NOTIFY_PANEL_SUCCESS_MESSAGE =
  'We will send an email to the address associated with your PLI account when this program is ready.';
export const NOTIFY_PANEL_GUEST_MESSAGE =
  'To receive an email notification when this program is ready for online viewing, please fill out and submit the form below.';
export const NOTIFY_PANEL_RECAPTCHA_ACTION = 'notify_me';
export const NOTIFY_PANEL_GRACEFUL_TRANSITION_SOURCE = 'gracefulTransition';
export const NOTIFY_PANEL_SALESFORCE_SOURCE = 'salesforce';
